export const getStyled = (theme) => ({
  chatContainer: {
    flex: 1,
    padding: theme.spacing(1),
    height: 'calc(100% - 48px)',
    overflowY: 'hidden',
    margin: 0,
  },
  chatPapper: {
    display: 'flex',
    height: '100%',
    width: '100%',
  },
  gridContainer: {
    width: '100%',
  },
  contactsWrapper: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    overflowY: 'hidden',
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#192734',
  },
  messagesWrapper: {
    position: 'relative',
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    overflow: 'hidden',
    flexGrow: 1,
  },
  welcomeMsg: {
    background: theme.custom.colors.tabHeaderBackground,
    display: 'flex',
    justifyContent: 'center',
    left: '25px',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    textAlign: 'center',
    padding: theme.spacing(2),
  },
  logo: {
    width: '70%',
    height: 'auto',
    margin: '0 auto',
    opacity: '0.03',
  },
});
